export default __webpack_public_path__ + "static/media/page4.4302f0e7.png";